import cx from 'clsx'
import { ElementType } from 'react'
import { Helmet } from 'react-helmet'

import { Hierarchy } from '@karakuri-web/faq-type'

import { toTopBreadcrumbs } from '../utils'
import { breadcrumb, stringifyJsonLd } from '../utils/ld'

import { BreadcrumbsComponent } from './BreadcrumbsComponent'

interface Props {
  current: Hierarchy
  url: string
  hierarchies?: Hierarchy[]
  onLinkClick?: (link: string, option: any) => void
  topTitle?: string
  LinkComponent?: ElementType
}

export function Breadcrumbs({
  url,
  current,
  hierarchies,
  onLinkClick,
  LinkComponent,
  topTitle = 'よくあるご質問',
}: Props) {
  const top = toTopBreadcrumbs(hierarchies || [], current, topTitle)

  return (
    <div className={cx('faq-breadcrumb')}>
      <Helmet>
        <script type="application/ld+json">{stringifyJsonLd(breadcrumb(url, top))}</script>
      </Helmet>
      <BreadcrumbsComponent links={top} onLinkClick={onLinkClick} LinkComponent={LinkComponent} />
    </div>
  )
}
